import { ComponentType, SVGProps } from "react";
import { Facebook, Instagram, Linkedin, Website, X, Youtube } from "@assets";

type ConnectionLink = {
	uuid: string;
	href: string;
	label: string;
	icon: ComponentType<SVGProps<SVGSVGElement>>;
};

export const connectionLinks: ConnectionLink[] = [
	{
		uuid: "a1972ebe-4042-485f-a90d-a7f9ba404328",
		href: "https://www.facebook.com/baseelpartners/",
		label: "Facebook",
		icon: Facebook,
	},
	{
		uuid: "a1972ebe-404c-47b7-b087-2704c62f5062",
		href: "https://www.instagram.com/baseelpartners/",
		label: "Instagram",
		icon: Instagram,
	},
	{
		uuid: "a1972ebe-404e-4b20-ba9f-acd65686fe4b",
		href: "https://www.linkedin.com/company/baseel/",
		label: "LinkedIn",
		icon: Linkedin,
	},
	{
		uuid: "a1972ebe-4050-42be-a09b-1f519875e1ed",
		href: "https://www.baseel.com",
		label: "Website",
		icon: Website,
	},
	{
		uuid: "a1972ebe-4052-49bf-843e-415dd4490718",
		href: "https://x.com/Baseelpartners",
		label: "X",
		icon: X,
	},
	{
		uuid: "a1972ebe-4054-45f3-825a-81a4b9c9067e",
		href: "https://www.youtube.com/@baseelpartners772",
		label: "YouTube",
		icon: Youtube,
	},
];
